<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">
        New Location
      </h4>
      <span v-if="validationError === true" style="color: red;">
        Missing fields. Make sure name, parent, location type, and timezone are filled out.
      </span>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <fg-input
            type="text"
            label="Name"
            placeholder="Name"
            v-model="location.name"
          />
        </div>
        <div
          class="col-md-6"
        >
          <label class="control-label">Location Type</label>
          <fg-input>
            <el-select
              class="select-default"
              size="large"
              placeholder="Location Type"
              v-model="location.locationType"
            >
              <el-option
                v-for="locationTypeOption in locationTypeOptions"
                class="select-default"
                :key="locationTypeOption.name"
                :value="locationTypeOption.name"
                :label="locationTypeOption.name"
              />
            </el-select>
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="control-label">Timezone</label>
          <fg-input>
            <el-select
              class="select-default"
              size="large"
              placeholder="Timezone"
              v-model="location.timezoneId"
            >
              <el-option
                v-for="timezoneOption in timezoneOptions"
                class="select-default"
                :key="timezoneOption.id"
                :label="timezoneOption.name"
                :value="timezoneOption.id"
              />
            </el-select>
          </fg-input>
        </div>
        <div class="col-md-6">
          <label class="control-label">Parent Location</label>
          <v-select
            style="margin-top:12px;"
            class="style-chooser"
            label="name"
            :options="locationOptions"
            v-model="location.parentLocation"
          />
        </div>
      </div>
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-info btn-fill btn-wd"
          v-if="!saving"
          @click="handleSave()"
        >
          Save Location
        </button>
        <button type="submit" class="btn btn-info btn-fill btn-wd" v-if="saving">
          Saving...
        </button>
      </div>
    </div> <!-- card body -->
  </div>
</template>
<script>
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const LocationsRepository = RepositoryFactory.get('locations');

function validateForm(name, parentLocation, timezoneId, locationType) {
    return !!name && !!parentLocation && !!timezoneId && !!locationType;
}

export default {
    data() {
        return {
            namespace: 'Locations',
            location: {
                name: '',
                parentLocation: '',
                timezoneId: '',
                locationType: ''
            },
            error: '',
            locationTypeOptions: [],
            timezoneOptions: [],
            locationOptions: [],
            validationError: '',
            saving: false
        };
    },
    computed: {
    },
    methods: {
        handleSave() {
            this.saving = true;
            this.validationError = false;

            if (!validateForm(
                this.location.name,
                this.location.parentLocation.id,
                this.location.timezoneId,
                this.location.locationType
            )) {
                this.validationError = true;
                this.saving = false;
                return;
            }
            LocationsRepository.storeLocation(this.location)
                .then((response) => {
                    this.saving = false;
                    this.$router.push({ name: 'Locations' });
                }).catch((error) => {
                    this.error = error;
                    this.$message(error.response.data.message);
                    this.saving = false;
                });
        },
        getTimezones() {
            LocationsRepository.getTimezones()
                .then((response) => {
                    this.timezoneOptions = response.data;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        getLocations() {
            LocationsRepository.getFocusLocations()
                .then((response) => {
                    this.locationOptions = response.data;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        getLocationTypeOptions() {
            LocationsRepository.getLocationTypeOptions()
                .then((response) => {
                    this.locationTypeOptions = response.data;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        }
    },
    created() {
        this.getTimezones();
        this.getLocations();
        this.getLocationTypeOptions();
    },
    mounted() {

    },

};
</script>

<style>
    .style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__dropdown-menu {
        background-color: white !important;
        border-color: #66615B !important;
        border-width: 2px !important;
        border-radius: 20px !important;
        color: #66615B !important;
    }
</style>
